import { Button, Dropdown, MenuProps } from "antd";
import * as Icon from "@ant-design/icons";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";

type AcoesComponentProps = {
  items: ItemMenuAcoes[];
  record: any;
};

const AcoesComponent = ({ items, record }: AcoesComponentProps) => {
  const findMenuItemByKey = (items: ItemMenuAcoes[], key: string): ItemMenuAcoes | undefined => {
    for (const item of items) {
      if (item.key === key) {
        return item;
      }
      if (item.children) {
        const found = findMenuItemByKey(item.children, key);
        if (found) {
          return found;
        }
      }
    }
    return undefined;
  };

  const transformItems = (items: ItemMenuAcoes[]): MenuProps["items"] => {
    return items.map((item) => ({
      label: item.label,
      key: item.key,
      icon: item.icon,
      type: item.type,
      disabled: item.disabled ? item.disabled(record) : false,
      children: item.children ? transformItems(item.children) : undefined,
    })) as MenuProps["items"];
  };

  const onClick: MenuProps["onClick"] = (e) => {
    e.domEvent.stopPropagation();
    const clickedItem = findMenuItemByKey(items, e.key);
    if (clickedItem?.function) {
      clickedItem.function(record);
    }
  };

  return (
    <Dropdown menu={{ items: transformItems(items), onClick }} trigger={["click"]}>
      <Button size="small">
        <Icon.EllipsisOutlined size={14} />
      </Button>
    </Dropdown>
  );
};

export default AcoesComponent;
